<script setup>
import {computed} from 'vue'
import { useScheduleItemStore } from "@/stores/ScheduleItemStore"

    const store = useScheduleItemStore()

    const props = defineProps({
        item: Object
    })
    const isWorkshop = computed(() => {
        return props.item.item_workshop !== false && props.item.item_workshop !== ''
    })
    const isGeneralSession = computed(() => {
        return props.item.item_gs !== false && props.item.item_gs !== ''
    })
    const defineClass = () => {
        const offset = `time-offset--${ props.item.startTimeMinutes }`
        if (isWorkshop.value) {
            return `part-of-ws-${ props.item.item_workshop } ${ offset }`
        } else if (isGeneralSession.value) {
            return `part-of-gs-${ props.item.item_gs } ${ offset }` 
        } else {
            return `${ offset }`
        }
    }
    const defineColumnStyle = () => {
        if ( props.item.item_location_is_column ) {
            return `loc-${ props.item.item_location } / span 1`
        } else {
            return '2 / -2'
        }
    }
    const partOf = () => {
        if ( isWorkshop.value ) {
            return props.item.item_ws_name
        } else if ( isGeneralSession.value ) {
            return props.item.item_gs_name
        } else {
            return ''
        }
    }

    const startTimeHours = computed(() => {
        return props.item.startTimeHours.startsWith('0') ? 
            props.item.startTimeHours.substring(1,2) :
                props.item.startTimeHours
    })


    const isBookmarked = () => {
        return store.bookmarkedIDs.findIndex( (id) => {
            return props.item.id === id
        } ) !== -1
    }
    const handleFavClick = () => {
        if ( ! isBookmarked() ) {
            store.addBookmark( props.item.id )
        } else {
            store.removeBookmark( props.item.id )
        }
    }


    const isPosterSearchResult = ( poster ) => {
        return poster.title.toLowerCase().includes(store.currentFilters.search.toLowerCase()) || poster.item_presenters_full.toLowerCase().includes(store.currentFilters.search.toLowerCase())
    }


    const handleModal = () => {
        store.setOpenModal( props.item, partOf(), 'single' )
        store.setModalState( true )
    }

    const handleTriggerFilter = ( key, value ) => {
        store.setCurrentFilter( key, value )
    }



    // const isStart = computed(() => {
    //     if ( isWorkshop.value ) {
    //         return store.scheduleItems.filter((el) => {
    //             return el.item_workshop === props.item.item_workshop
    //         })[0].id === props.item.id
    //     } else if ( isGeneralSession.value ) {
    //         return store.scheduleItems.filter((el) => {
    //             return el.item_gs === props.item.item_gs
    //         })[0].id === props.item.id
    //     } else {
    //         return false
    //     }
    // })

    
</script>
<template>
    <div class="schedule-item" 
        :class="`${ defineClass()} ${ !item.item_location_is_column ? 'is-plenary' : '' }`"
        :style="`--duration: ${ item.durationInText }; grid-row: time-${ startTimeHours } / span 1; grid-column: ${ defineColumnStyle() }`"
        :data-title="item.title" :data-slug="item.slug" 
        :data-type="item.item_type" :data-location="item.item_location_name" 
        :data-startat="item.dayAsSlug + ' ' + item.startTimeInText" :data-duration="item.durationInText + ' minutes'"
        :data-presenters="item.item_presenters_full" :data-file="item.item_paper_abstract_url" :data-id="item.id"
        :data-partof="partOf()"
        :id="'item-preview-' + item.id"
        >
        <div class="schedule-item__meta">
            <span class="schedule-item__meta__time schedule-item__meta__label">
                {{ item.startTimeInText }} - {{ item.item_ends_at.substring(11, 16) }} 
            </span>
            <span v-if="item.item_location_name !== ''" class="schedule-item__meta__location schedule-item__meta__label trigger-filter-data" :data-filterLocation="item.item_location" @click.prevent="handleTriggerFilter( 'location', item.item_location )">
                {{ item.item_location_roomnumber && item.item_location_roomnumber !== '' ? item.item_location_roomnumber + ' - ' : '' }}{{ item.item_location_name }}
            </span>
        </div>
        <div class="schedule-item__info">
            <span v-if="isWorkshop" class="schedule-item__meta__ws trigger-filter-data" :data-filterWorkshop="item.item_ws_slug" @click.prevent="handleTriggerFilter( 'workshop', item.item_ws_slug )">
                {{ item.item_ws_short_name }}
            </span>
            <span v-else-if="isGeneralSession && item.item_type !== 'plenary'" class="schedule-item__meta__gs trigger-filter-data" :data-filterGeneralSession="item.item_gs_slug" @click.prevent="handleTriggerFilter( 'session', item.item_gs_slug )">
                {{ item.item_gs_short_name }}
            </span>


            <div class="schedule-item__info__content">
                
                <span v-if="item.item_presenters_full !== '' && item.item_type !== 'plenary'" class="schedule-item__speakers schedule-item__show_as_title">
                    {{ item.item_presenters_full }}
                </span>
                <!-- <span  class="schedule-item__title" :class="item.item_type === 'plenary' || item.item_type === 'poster' ? 'schedule-item__show_as_title' : ''" v-html="item.title"></span> -->
                <span  class="schedule-item__title" :class="item.item_type === 'plenary' || item.item_type === 'poster' ? 'schedule-item__show_as_title' : ''">{{ item.title }}</span>
                <span v-if="item.item_type === 'poster'" class="schedule-item__posters">
                    <span v-for="(poster, ind) in item.item_poster_papers_programme" :key="ind" class="schedule-item__posters__poster">
                        <span :class="store.currentFilters.search !== '' && isPosterSearchResult( poster ) ? 'poster__search-highlight' : ''">
                            {{ poster.item_presenters_short }}
                        </span>
                    </span>
                </span>

            </div>
            <div class="schedule-item__info__more">
                <a 
                    :href="'#' + item.slug" 
                    class="schedule-item__actions__open open-detail"
                    @click.prevent="handleModal()"
                >Show all info &rsaquo;</a>
            </div>
        </div>
        <div class="schedule-item__extra-content hidden"></div>
        <div class="schedule-item__presentations-list presentations-list hidden"></div>
        <div class="schedule-item__actions">
            <a 
                :href="'#fav-' + item.slug" 
                :data-slug="item.slug" 
                class="schedule-item__actions__fav"
                :class="isBookmarked() ? 'schedule-item__actions__fav--active' : ''"
                @click.stop.prevent="handleFavClick()"
            ><span class="screen-reader-text"></span><svg class="svgicon"><use xlink:href="#svg-star"></use></svg></a>
        </div>
    </div>
</template>



